(function () {
  var JUDGEME_PUBLIC_TOKEN = "nWMJB08Mfa2aUK1qcisJLj_3U-k";

  function init() {
    var container = document.querySelector("[data-pooled-reviews]");
    if (!container) return;

    var shopDomain = container.getAttribute("data-shop-domain");
    var idsScript = container.querySelector("[data-sibling-ids]");
    if (!idsScript) return;

    var ids;
    try {
      ids = JSON.parse(idsScript.textContent);
    } catch (e) {
      return;
    }
    if (!ids || ids.length < 2) return;

    var fetches = ids.map(function (id) {
      var url =
        "https://judge.me/api/v1/widgets/preview_badge?shop_domain=" +
        encodeURIComponent(shopDomain) +
        "&api_token=" +
        JUDGEME_PUBLIC_TOKEN +
        "&external_id=" +
        id;
      return fetch(url)
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          var match = data.badge && data.badge.match(
            /data-average-rating='([\d.]+)'[^>]*data-number-of-reviews='(\d+)'/
          );
          if (!match) return { rating: 0, count: 0 };
          return { rating: parseFloat(match[1]), count: parseInt(match[2], 10) };
        })
        .catch(function () {
          return { rating: 0, count: 0 };
        });
    });

    Promise.all(fetches).then(function (results) {
      var totalCount = 0;
      var weightedSum = 0;
      results.forEach(function (r) {
        totalCount += r.count;
        weightedSum += r.rating * r.count;
      });
      if (totalCount === 0) return;

      var avg = weightedSum / totalCount;
      var avgRounded = Math.round(avg * 10) / 10;

      var starsEl = container.querySelector(".jdgm-pooled-stars");
      var textEl = container.querySelector(".jdgm-pooled-text");
      if (starsEl) starsEl.textContent = "★".repeat(Math.round(avg)) + "☆".repeat(5 - Math.round(avg));
      if (textEl) textEl.textContent = avgRounded + " ★ | " + totalCount + " reviews";

      container.style.display = "block";

      // hide the native single-product badge if present, to avoid showing two conflicting numbers
      var nativeBadge = document.querySelector(".jdgm-prev-badge");
      if (nativeBadge) nativeBadge.style.display = "none";
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
